/* eslint-disable */
// This file has been auto-generated by the i18n build script

export const pluralizationRules = {
    fr: (n: number) => Number(n > 1),
    'en-GB': (n: number) => Number(n !== 1),
    'en-US': (n: number) => Number(n !== 1),
    en: (n: number) => Number(n !== 1),
    'es-ES': (n: number) => Number(n !== 1),
    es: (n: number) => Number(n !== 1),
    'fr-CA': (n: number) => Number(n > 1),
    'fr-FR': (n: number) => Number(n > 1),
    it: (n: number) => Number(n !== 1),
}
export const fallbackLocale = {
    "default": [
        "fr"
    ]
}
